import React, {useEffect, useState} from 'react';
import {getNavData} from "../../Api/home";
import NavBar from "../../Components/NavBar";
import Footer from "../../Components/Footer";
import ContactBtn from "../../Components/ContactBtn";

const Layout = (props) => {

    const [data, setData] = useState([])

    useEffect(() => {
        getNavData().then((response) => {
            setData(response.data.data)
        })
    }, [])

    if (data === []) return (<div>Loading...</div>);

    return (
        <div>
            <NavBar dataNav={data}/>
            {props.children}
            <Footer dataFooter={data.insitutional_links}/>
            <ContactBtn/>
        </div>
    )
}


export default Layout;
